<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/promotion")
          i.fas.fa-gift
          span.ml-1 {{ $t("ui.promotion") }}
      b-breadcrumb-item
        router-link(to="/promotion/promotion_list")
          i.fas.fa-th-list
          span.ml-1 {{ $tc("ui.promotion_list", 2) }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12
              div.form-row
                .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-gift
                    DebounceInput(required autofocus type="text" v-model="search_id" :placeholder="$t('ui.promo_id')" @keyup.enter.native="submit")
                .col-xs-2.col-sm-2.col-md-2.col-lg-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="submit"
                    variant="success"
                    size="sm"
                  )
          div.row
            div.col-md-12
              b-button(v-b-modal.addPromotion type="button" variant="primary" size="sm")
                i.fa.fa-plus
                span {{ $t("ui.add_promotion") }}
        div.card-body.p-1
          b-row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="filterList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                template(v-slot:cell(index)="row")
                  span {{ row.index + 1 }}
                template(v-slot:cell(action)="row")
                  //- span
                  //-   b-link.fa.fa-pause-circle.text-danger(v-if="row.item.profile_status == 'BLOCK'" href="#" @click="unblockProfile(row.item)" :title="$t('ui.unblock')")
                  //- span
                  //-   b-link.fa.fa-search.text-dark(href="#" @click="onEdit(row.item, 'details')" :title="$t('ui.details')")
                  span
                    b-link.fa.fa-edit.text-primary(href="#" @click="onEdit(row.item, 'edit')" :title="$t('ui.edit')")
    addPromotion(@clicked="submit")
    editPromotion(ref="editPromotion" @clicked="submit" :pid="pid" :pname="pname" :pdesc="pdesc")
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
import SubmitButton from "@/library/SubmitButton.vue"
import DebounceInput from "@/library/DebounceInput"
import currency from "@/components/currency.vue"
import addPromotion from "@/components/promotion/addPromotion.vue"
import editPromotion from "@/components/promotion/editPromotion.vue"

export default {
  components: {
    SubmitButton,
    DebounceInput,
    currency,
    addPromotion,
    editPromotion
  },
  data() {
    return {
      loading: false,
      pid: "",
      pname: "",
      pdesc: "",
      search_id: "",
      filter: null,
      sortBy: "promo_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0,
      list: [],
      submission: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center align-middle",
          thStyle: {
            width: "3% !important"
          }
        },
        {
          key: "promo_id",
          label: this.$t("ui.promo_id"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "text-center",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "promo_name",
          label: this.$t("ui.promo_name"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "promo_desc",
          label: this.$t("ui.promo_desc"),
          class: "text-left align-middle",
          sortable: true,
          thStyle: {
            width: "50%"
          }
        },
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    filterList() {
      return this.list.filter(x => x.promo_id.toUpperCase() != 'NB')
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    changedPage: function(pageNo) {
      this.currentPage = pageNo
      this.submit()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged: function(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable: function() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    onEdit: function(item, mode) {
      this.pid = item.promo_id
      this.pname = item.promo_name
      this.pdesc = item.promo_desc
      // console.log(this.$refs)
      this.$refs.editPromotion.$refs.editPromotion.show()
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_id = this.search_id
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("promotion/getPromotionList", { search_id, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            if (this.submission.success == true) {
              this.list = response.data
              this.totalRows = response.data.length > 0 ? this.list[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
};
</script>